var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Sidebar',{attrs:{"docs":_vm.docs,"currentDocs":_vm.currentDocs,"currentPage":_vm.currentPage}}),_c('v-main',[_c('v-container',{staticClass:"py-8 px-6",attrs:{"fluid":""}},[_c('DocumentationContent',{attrs:{"docs":_vm.docs,"currentDocs":_vm.currentDocs,"currentPage":_vm.currentPage,"currentEndPoint":_vm.currentEndPoint}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }